import styled from 'styled-components';

import BadgeComponent from '../../../../components/Badge';

export const Badge = styled(BadgeComponent)`
  padding: 5px 17px !important;
`;
